import { ca } from '@cian/analytics';
import { ICommonNewbuilding } from '../../types/newbuilding/newbuildings';
import { getNewbuildingInfo } from '../../utils/analytics';

export function trackSimilarNewbuildingsBlockAppearance(similarNewbuildings: ICommonNewbuilding[]) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'show_similar_JK',
    label: '',
    ds: 'desktop',
    products: similarNewbuildings.map((similarNewbuilding, position) =>
      getNewbuildingInfo(similarNewbuilding, position + 1, 'similar_JK'),
    ),
    modelVersion: '1',
  });
}

export function trackTransferToSimilarNewbuilding(similarNewbuildings: ICommonNewbuilding[], index: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'click_similar_JK',
    label: '',
    ds: 'desktop',
    products: [getNewbuildingInfo(similarNewbuildings[index], index + 1, 'similar_JK')],
    modelVersion: '1',
  });
}
